import { render, staticRenderFns } from "./MailIntegrationDetail.vue?vue&type=template&id=66bcd090&scoped=true"
import script from "./MailIntegrationDetail.vue?vue&type=script&lang=js"
export * from "./MailIntegrationDetail.vue?vue&type=script&lang=js"
import style0 from "./MailIntegrationDetail.vue?vue&type=style&index=0&id=66bcd090&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bcd090",
  null
  
)

export default component.exports